import React, { useState, useEffect, useContext } from "react";

import axios from "axios";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  IconButton,
  Avatar,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardHeader,
  FormControlLabel,
  FormGroup,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Collapse from "@mui/material/Collapse";
import CardActions from "@mui/material/CardActions";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useErrValidate } from "../utilitis/AuthorizationPage";
import { RolesContext } from "../context/User";
import FormulaForm from "../component/Form";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import DeletePopUp from "../component/DeletedPopUp";
import EditIcon from "@mui/icons-material/Edit";
import Alert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import CustomCard from "../styleComp/CustomCard";
import { useNavigate } from "react-router-dom";

export default function AdminList() {
  const [rolesList, setRolesList] = useState([]);
  const [expanded, setExpanded] = useState();
  const [admin, setAdmin] = useState([]);
  const [delPhone, setdelPhone] = useState("");
  const [text, setText] = useState("");
  const [alert, setAlert] = useState(false);
  const { validationPage } = useErrValidate();
  const [disable, setDisable] = useState(true);
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const [value, setValue] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [customerDel, setCustomerDel] = useState(null);
  const [refreshEffect, setRefreshEffect] = useState(false);
  const [alertupdated, setAlertupdated] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [userupdate, setUserupdate] = useState(false);
  const [adminPhone, setadminPhone] = useState(null);
  const [alert_input, setAlert_input] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [errorAlerttext, setErrorAlertTest] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    validationPage("roles");
  }, [stateroles.userId]);

  useEffect(() => {
    setadminPhone(stateroles.phone);
    async function fetchRoles() {
      try {
        const response = await axios.get(
          `adminPermissions/getContacts`,

          {
            withCredentials: true,
          }
        );

        if (response.status == 200) {
          setRolesList(response.data["contacts"]);
        }
      } catch (error) {
        if (error.response.status == 403) {
          navigate("/");
        }
      }
    }

    fetchRoles();
  }, [refreshEffect]);

  const updatedNewNumber = (newPhoneValue, indexToUpdate) => {
    const updatedRolesList = [...rolesList];

    // Update the phone number of the specific object at indexToUpdate
    updatedRolesList[indexToUpdate] = {
      ...updatedRolesList[indexToUpdate],
      newphone: newPhoneValue,
    };

    // Update the state with the modified array
    setRolesList(updatedRolesList);
  };

  const handleCheckboxChange = (event, name, index) => {
    index = index;
    const value = event.target.checked;
    const updatedRolesList = [...rolesList];
    if (updatedRolesList[index].roles.indexOf(name) == -1) {
      updatedRolesList[index].roles.push(name);

      setRolesList(updatedRolesList);
    } else {
      updatedRolesList[index].roles.splice(
        updatedRolesList[index].roles.indexOf(name),

        1
      );

      setRolesList(updatedRolesList);
    }
  };

  const openUpdate = (index) => {
    setSelectedRow(index);
    setAlertupdated(true);
    setDisable(false);
  };

  const handleValueUpdate = (updatedValue) => {
    setValue(updatedValue);
  };

  const refresh = (updatedValue) => {
    setRefreshEffect(updatedValue);
  };

  const handleButtonClicked = async (checkboxval) => {
    if (checkboxval == false) {
      try {
        const response = await axios.post(
          `/adminPermissions/remove_contact_for_specific_cust`,
          {
            wtaxnum: stateroles.compNum,
            phone: delPhone,
          }
        );

        if (response.status == 200) {
          setRolesList(rolesList.filter((item) => item.phone != delPhone));
          setDisable(true);
          setSelectedRow(null);
          setAlert(true);
          setText("המשתמש נמחק בהצלחה");
          setTimeout(() => {
            setAlert(false);

            setText("");
          }, 10000);
        }
      } catch (error) {
        if (error.response.status == 404) {
          setErrorAlert(true);
          setErrorAlertTest("התקבלה שגיאה והנתונים לא נשמרו");
          setTimeout(() => {
            setErrorAlert(false);
          }, 10000);
        } else if (error.response.status == 400) {
          setErrorAlert(true);
          setErrorAlertTest("אין הרשאות למחיקת משתמש");
          setTimeout(() => {
            setErrorAlert(false);
          }, 10000);
        }
      }
    } else if (checkboxval == true) {
      try {
        const response = await axios.post(
          `/adminPermissions/remove_contact_to_all_cust`,
          {
            wtaxnum: stateroles.compNum,
            phone: delPhone,
          }
        );

        if (response.status == 200) {
          setRolesList(rolesList.filter((item) => item.phone != delPhone));
          setDisable(true);
          setSelectedRow(null);
          setAlert(true);
          setText("המשתמש נמחק בהצלחה");
          setTimeout(() => {
            setAlert(false);

            setText("");
          }, 10000);
        }
      } catch (error) {
        if (error.response.status == 404) {
          setErrorAlert(true);
          setErrorAlertTest("התקבלה שגיאה והנתונים לא נשמרו");
          setTimeout(() => {
            setErrorAlert(false);
          }, 10000);
        } else if (error.response.status == 400) {
          setErrorAlert(true);
          setErrorAlertTest("אין הרשאות למחיקת משתמש");
          setTimeout(() => {
            setErrorAlert(false);
          }, 10000);
        }
      }
    }

    setRefreshEffect(refreshEffect == true ? false : true);
  };

  const handleUpdate = async (phone, index, person) => {
    setAlert_input(false);
    setAlertText("");
    if (person == "user") {
      try {
        const response = await axios.post(`/adminPermissions/modifyUser`, {
          wtaxnum: stateroles.compNum,
          phone: phone,
          action: "$set",
          updates: {
            ROLES: rolesList[index].roles,
            PHONE: rolesList[index].newphone
              ? rolesList[index].newphone
              : phone,
          },
        });

        if (response.status == 200) {
          setDisable(true);
          setSelectedRow(null);
          setAlert(true);
          setText("השינוי עודכנו בהצלחה");
          setTimeout(() => {
            setAlert(false);

            setText("");
          }, 10000);
          setAlertupdated(false);
        }
      } catch (error) {
        if (error.response.status == 401) {
          setAlert_input(true);
          setAlertText("מספר טלפון קיים בחברה זאת");
        } else if (error.response.status == 404) {
          setErrorAlert(true);
          setErrorAlertTest("התקבלה שגיאה והנתונים לא נשמרו");
          setTimeout(() => {
            setErrorAlert(false);
          }, 10000);
        } else if (error.response.status == 400) {
          setErrorAlert(true);
          setErrorAlertTest("אין הרשאות לשינוי משתמש");
          setTimeout(() => {
            setErrorAlert(false);
          }, 10000);
          setUserupdate(false);
          setAlertupdated(false);
          setDisable(true);
          setSelectedRow(null);
        }
      }
    } else if (person == "self") {
      if (adminPhone != null) {
        try {
          const response = await axios.post(`/adminPermissions/modifyUser`, {
            wtaxnum: stateroles.compNum,
            phone: stateroles.phone,
            action: "$set",
            updates: {
              ROLES: stateroles.roles,
              PHONE: adminPhone ? adminPhone : stateroles.phone,
            },
          });

          if (response.status == 200) {
            setDisable(true);
            setSelectedRow(null);
            setAlert(true);
            setText("השינוי עודכנו בהצלחה");
            setTimeout(() => {
              setAlert(false);

              setText("");
            }, 10000);
            setUserupdate(false);
            setAlertupdated(false);
          }
        } catch (error) {
          if (error.response.status == 400) {
            setAlert_input(true);
            setAlertText("מספר טלפון קיים בחברה זאת");
          }
        }
      } else {
        setUserupdate(false);
        setAlertupdated(false);
      }
    }
    setRefreshEffect(refreshEffect == true ? false : true);
  };

  const handleDelete = (phone, index, customer) => {
    setCustomerDel(customer);
    setdelPhone(phone);
    handleValueUpdate(true);
  };

  const openRoles = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const adminewPhone = (e) => {
    setadminPhone(e.target.value);
  };

  return (
    <Container maxWidth="100%" sx={{ marginTop: "-1.5rem" }}>
      <Box
        sx={{
          maxWidth: "100%",
          mx: "auto",
          mt: 3,
          flexGrow: 1,
          display: { xs: "none", md: "flex" },
        }}
      >
        <CustomCard overflowCard={"scroll"}>
          <Typography variant="h6" align="left" mb={3}>
            תפקידים והרשאות
          </Typography>

          {stateroles.userId ? (
            <div style={{ marginBottom: "2rem" }}>
              <Grid container spacing={4} alignItems="center">
                <Grid item>
                  <Avatar
                    // sx={{ width: 56, height: 56, bgcolor: "#1976d2" }}

                    sx={{ width: 56, height: 56, bgcolor: "#1976d2" }}
                    alt="frist_letter_of_name"
                  >
                    {stateroles.name.charAt(0)}
                  </Avatar>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <Typography variant="h5">
                    {stateroles.name}
                    {userupdate ? (
                      <IconButton
                        onClick={() =>
                          handleUpdate(stateroles.phone, null, "self")
                        }
                      >
                        <CheckRoundedIcon />
                      </IconButton>
                    ) : (
                      <IconButton
                        onClick={() => {
                          setUserupdate(true);
                          setAlertupdated(true);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                  </Typography>
                  <Grid container>
                    <Typography
                      variant="body2"
                      sx={{ marginRight: "2rem", marginTop: "0.5rem" }}
                    >
                      טלפון
                    </Typography>
                    <TextField
                      id="standard-basic"
                      onChange={adminewPhone}
                      value={adminPhone ? adminPhone : ""}
                      variant="standard"
                      disabled={!userupdate}
                      InputProps={{
                        disableUnderline: !userupdate ? true : false,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </div>
          ) : null}

          <FormulaForm
            idUser={stateroles.userId ? stateroles.userId : ""}
            refresh={refresh}
            refreshEffect={refreshEffect}
          />
          {alert ? (
            <Alert sx={{ marginBottom: "1rem" }} severity="success">
              {text}
            </Alert>
          ) : null}
          {alertupdated ? (
            <Alert
              sx={{ marginBottom: "0.5rem", marginTop: "0.5rem" }}
              severity="warning"
            >
              הנתונים ישמרו רק לאחר אישור בכפתור
              <CheckRoundedIcon
                sx={{
                  color: "green",
                  fontSize: 20,
                  marginBottom: "-4px",
                  marginLeft: "4px",
                  marginRight: "4px",
                }}
              />
            </Alert>
          ) : null}

          {errorAlert ? (
            <Alert
              sx={{ marginBottom: "0.5rem", marginTop: "0.5rem" }}
              severity="warning"
            >
              {errorAlerttext}
            </Alert>
          ) : null}

          <Box
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TableContainer component={Paper}>
              <Table aria-label="roles table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">שם</TableCell>
                    <TableCell align="center">טלפון</TableCell>
                    <TableCell align="center">הזמנות</TableCell>
                    <TableCell align="center">חשבוניות לתשלום</TableCell>
                    <TableCell align="center">חשבוניות וקבלות</TableCell>
                    <TableCell align="center">תעודות משלוח </TableCell>
                    <TableCell align="center">הרשאות </TableCell>
                    <TableCell align="center"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rolesList.map((role, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{role.name}</TableCell>
                      <TableCell align="center">
                        {selectedRow === index ? (
                          <TextField
                            id="standard-basic"
                            helperText={alert_input ? alertText : ""}
                            error={alert_input}
                            onChange={(e) =>
                              updatedNewNumber(
                                e.target.value,
                                index,
                                role.phone
                              )
                            }
                            value={
                              !alertupdated ? role.phone : role.newphone || ""
                            }
                            variant="standard"
                            disabled={false}
                            InputProps={{
                              disableUnderline: false,
                            }}
                            inputProps={{ style: { textAlign: "center" } }}
                          />
                        ) : (
                          <TextField
                            id="standard-basic"
                            onChange={(e) =>
                              updatedNewNumber(
                                e.target.value,
                                index,
                                role.phone
                              )
                            }
                            value={
                              !alertupdated ? role.phone : role.newphone || ""
                            }
                            variant="standard"
                            disabled={true}
                            inputProps={{ style: { textAlign: "center" } }}
                            InputProps={{
                              disableUnderline: true,
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          disabled={disable || selectedRow !== index}
                          checked={
                            role.roles
                              ? role.roles.includes("openorder")
                              : false
                          }
                          onChange={(event) =>
                            handleCheckboxChange(event, "openorder", index)
                          }
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Checkbox
                          disabled={disable || selectedRow !== index}
                          checked={
                            role.roles
                              ? role.roles.includes("linkopeninvoice")
                              : false
                          }
                          onChange={(event) =>
                            handleCheckboxChange(
                              event,
                              "linkopeninvoice",
                              index
                            )
                          }
                        />
                      </TableCell>

                      <TableCell align="center">
                        <Checkbox
                          disabled={disable || selectedRow !== index}
                          checked={
                            role.roles
                              ? role.roles.includes("getinvoice")
                              : false
                          }
                          onChange={(event) =>
                            handleCheckboxChange(event, "getinvoice", index)
                          }
                        />
                      </TableCell>

                      <TableCell align="center">
                        <Checkbox
                          disabled={disable || selectedRow !== index}
                          checked={
                            role.roles ? role.roles.includes("shipping") : false
                          }
                          onChange={(event) =>
                            handleCheckboxChange(event, "shipping", index)
                          }
                        />
                      </TableCell>

                      <TableCell align="center">
                        <Checkbox
                          disabled={disable || selectedRow !== index}
                          checked={
                            role.roles ? role.roles.includes("roles") : false
                          }
                          onChange={(event) =>
                            handleCheckboxChange(event, "roles", index)
                          }
                        />
                      </TableCell>

                      <TableCell align="center">
                        {selectedRow === index ? (
                          <Tooltip title="שמירה שינוים">
                            <IconButton
                              onClick={() =>
                                handleUpdate(role.phone, index, "user")
                              }
                            >
                              <CheckRoundedIcon
                                sx={{ color: "green", fontSize: 30 }}
                              />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="שינוי הרשאות משתמש ">
                            <IconButton onClick={() => openUpdate(index)}>
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                        )}

                        <Tooltip title="מחיקת משתמש">
                          <IconButton
                            onClick={() =>
                              handleDelete(role.phone, index, role.customers)
                            }
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* {alert ? (
        <Alert sx={{ marginTop: "1rem" }} severity="success">
          {text}
        </Alert>
      ) : null} */}

          <DeletePopUp
            value={value}
            onValueUpdate={handleValueUpdate}
            onButtonClicked={handleButtonClicked}
          />
        </CustomCard>
      </Box>
      <Box
        sx={{
          maxWidth: "100%",
          mx: "auto",
          mt: 3,
          display: { xs: "block", md: "none" },
          marginBottom: "2rem",
        }}
      >
        <Typography variant="h6" align="left" mb={3}>
          תפקידים והרשאות
        </Typography>

        {stateroles.userId ? (
          <div style={{ marginBottom: "2rem" }}>
            <Grid container spacing={4} alignItems="center">
              <Grid item>
                <Avatar
                  // sx={{ width: 56, height: 56, bgcolor: "#1976d2" }}

                  sx={{ width: 56, height: 56, bgcolor: "#1976d2" }}
                  alt="frist_letter_of_name"
                >
                  {stateroles.name.charAt(0)}
                </Avatar>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <Typography variant="h5">
                  {stateroles.name}
                  {userupdate ? (
                    <IconButton
                      onClick={() =>
                        handleUpdate(stateroles.phone, null, "self")
                      }
                    >
                      <CheckRoundedIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      onClick={() => {
                        setUserupdate(true);
                        setAlertupdated(true);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  )}
                </Typography>
                <Grid container>
                  <Typography
                    variant="body2"
                    sx={{ marginRight: "2rem", marginTop: "0.5rem" }}
                  >
                    טלפון
                  </Typography>
                  <TextField
                    id="standard-basic"
                    onChange={adminewPhone}
                    value={adminPhone ? adminPhone : ""}
                    variant="standard"
                    disabled={!userupdate}
                    InputProps={{
                      disableUnderline: !userupdate ? true : false,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </div>
        ) : null}

        <FormulaForm
          idUser={stateroles.userId ? stateroles.userId : ""}
          refresh={refresh}
          refreshEffect={refreshEffect}
        />
        {alert ? (
          <Alert sx={{ marginBottom: "1rem" }} severity="success">
            {text}
          </Alert>
        ) : null}
        {alertupdated ? (
          <Alert
            sx={{ marginBottom: "0.5rem", marginTop: "0.5rem" }}
            severity="warning"
          >
            הנתונים ישמרו רק לאחר אישור בכפתור
            <CheckRoundedIcon
              sx={{
                color: "green",
                fontSize: 20,
                marginBottom: "-4px",
                marginLeft: "4px",
                marginRight: "4px",
              }}
            />
          </Alert>
        ) : null}

        {errorAlert ? (
          <Alert
            sx={{ marginBottom: "0.5rem", marginTop: "0.5rem" }}
            severity="warning"
          >
            התקבלה שגיאה והנתונים לא נשמרו
          </Alert>
        ) : null}

        <Box
          sx={{
            flexGrow: 1,
            display: { xs: "flex", md: "none" },
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid container sx={{ marginTop: "0.5rem" }}>
            {rolesList.map((role, index) => (
              <Grid item xs={12} key={index}>
                <Card variant="outlined" sx={{ marginTop: "0.5rem" }}>
                  <CardContent>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2">שם: {role.name}</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid
                          container
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          <Typography variant="body2">מחיקת משתמש</Typography>
                          <Tooltip title="מחיקת משתמש">
                            <IconButton
                              onClick={() =>
                                handleDelete(role.phone, index, role.customers)
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2">
                          טלפון: {role.phone}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Grid
                          container
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          <CardActions disableSpacing>
                            <Typography variant="body2">הרשאות</Typography>
                            <Tooltip title="הרשאות משתמש">
                              <IconButton onClick={() => openRoles(index)}>
                                <ExpandMoreIcon />
                              </IconButton>
                            </Tooltip>
                          </CardActions>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>

                  <Collapse
                    in={expanded === index}
                    timeout="auto"
                    unmountOnExit
                  >
                    <CardContent>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox />}
                          disabled={disable || selectedRow !== index}
                          checked={
                            role.roles
                              ? role.roles.includes("openorder")
                              : false
                          }
                          label=" הזמנות פתוחות"
                          onChange={(event) =>
                            handleCheckboxChange(event, "openorder", index)
                          }
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox />}
                          disabled={disable || selectedRow !== index}
                          checked={
                            role.roles
                              ? role.roles.includes("linkopeninvoice")
                              : false
                          }
                          label=" חשבוניות פתוחות"
                          onChange={(event) =>
                            handleCheckboxChange(
                              event,
                              "linkopeninvoice",
                              index
                            )
                          }
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox />}
                          disabled={disable || selectedRow !== index}
                          checked={
                            role.roles
                              ? role.roles.includes("getinvoice")
                              : false
                          }
                          label=" צפייה חשבוניות/קבלות"
                          onChange={(event) =>
                            handleCheckboxChange(event, "getinvoice", index)
                          }
                        />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox />}
                          disabled={disable || selectedRow !== index}
                          checked={
                            role.roles ? role.roles.includes("roles") : false
                          }
                          label="  הרשאות"
                          onChange={(event) =>
                            handleCheckboxChange(event, "roles", index)
                          }
                        />
                      </FormGroup>
                      {selectedRow === index ? (
                        <Tooltip title="שמירה שינוים">
                          <IconButton
                            sx={{ padding: "6px" }}
                            onClick={() =>
                              handleUpdate(role.phone, index, "user")
                            }
                          >
                            <CheckRoundedIcon
                              sx={{ color: "green", fontSize: 30 }}
                            />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title="שינוי הרשאות משתמש ">
                          <IconButton
                            onClick={() => openUpdate(index)}
                            sx={{ padding: "6px" }}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </CardContent>
                  </Collapse>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Container>
  );
}
